var _linearGradient, _linearGradient2, _linearGradient3, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b47f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 7.43077,
    x2: 41.7972,
    xlinkHref: "#a",
    y1: 19.5193,
    y2: -18.5446
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 14.5885,
    x2: 32.7263,
    xlinkHref: "#a",
    y1: 10.9685,
    y2: -9.12078
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 19v-1.6459c0-.8178-.4979-1.5533-1.2572-1.857l-2.0342-.8136c-.9657-.3864-2.0664.0321-2.5316.9625l-.177.354s-2.5-.5-4.5-2.5-2.5-4.5-2.5-4.5l.35402-.17701c.93036-.46518 1.34883-1.56585.96252-2.53163l-.81365-2.03414c-.30373-.75932-1.03915-1.25722-1.85696-1.25722h-1.64593c-1.10457 0-2 .89543-2 2 0 8.8366 7.1634 16 16 16 1.1046 0 2-.8954 2-2z",
    fill: "url(#b)",
    opacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "url(#c)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.25 7c0-.41421.3358-.75.75-.75.6238 0 1.2414.12286 1.8177.36157s1.1.58859 1.5411 1.02967c.441.44108.7909.96472 1.0296 1.54101.2387.5763.3616 1.19395.3616 1.81775 0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75c0-.4268-.0841-.8494-.2474-1.24372-.1633-.39431-.4027-.75259-.7045-1.05438s-.6601-.54118-1.0544-.70451-.8169-.24739-1.2437-.24739c-.4142 0-.75-.33579-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.25 3c0-.41421.3358-.75.75-.75 1.1491 0 2.2869.22633 3.3485.66605 1.0616.43973 2.0262 1.08425 2.8387 1.89677.8125.81251 1.457 1.7771 1.8967 2.8387.4398 1.0616.6661 2.19941.6661 3.34848 0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75c0-.9521-.1875-1.89484-.5519-2.77446-.3643-.87961-.8984-1.67884-1.5716-2.35206-.6732-.67323-1.4724-1.20726-2.352-1.57161-.8797-.36434-1.8224-.55187-2.7745-.55187-.4142 0-.75-.33579-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/calling.8e6d90c9230eb95a86ffae147a4fa6f5.svg";
export { ForwardRef as ReactComponent };